<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Inscription CeV</strong>
          </div>
          <b-row>
            <h6 style="margin-left:14px;color:#990000;">Recherche de l'existence de la structure dans CeV</h6>
            <b-col md="12" v-if="etape2 === false">
              <b-form @submit.prevent="searchStructure">
                <label><u>Etape 1 : Saisie du SIREN</u></label>
                <b-row class="mb-1">
                  <b-col sm="2">
                    <label for="siren"><strong>SIREN : </strong></label>
                  </b-col>
                  <b-col>
                    <b-form-input
                      id="siren"
                      type="text"
                      :class="{hasError: errors.siren !== ''}"
                      v-model="siren"
                    />
                    <span class="field-error">{{ errors.siren }}</span>
                  </b-col>
                </b-row>
                <div class="mt-4" slot="footer">
                  <b-button type="submit" size="md" class="pull-right" variant="primary">
                    <i class="fa fa-arrow-right"/> Etape suivante
                  </b-button>
                </div>
              </b-form>
              <!-- <span>
                - <a @click="searchAdmin()" target="_BLANK" class="bleu_clair"> Changement administrateur</a><br>
                - <a @click="searchSiret()" target="_BLANK" class="bleu_clair"> Changement raison sociale CeV</a>
              </span> -->
            </b-col>
            <b-col md="12" v-if="etape2 === true">
              <b-form @submit.prevent="searchFromBre">
                <label v-if="sirenConnu === false"><u>Etape 2 : SIREN inconnu de CeV : Création d'un nouveau SIRET</u></label>
                <label v-if="sirenConnu === true"><u>Etape 2 : SIREN connu de CeV : choix d'un SIRET existant ou création d'un nouveau SIRET</u></label>
                <b-row class="mb-1">
                  <b-col sm="2">
                    <label for="siren"><strong>SIREN : </strong></label>
                  </b-col>
                  <b-col sm="2">
                    <label>{{ siren }}</label><br>
                  </b-col>
                  <b-col sm="1">
                    <label for="nic"><strong>NIC : </strong></label>
                  </b-col>
                  <b-col sm="5" v-if="sirenConnu === false">
                    <b-form-input
                      id="nic"
                      type="text"
                      :class="{hasError: errors.inputNic !== ''}"
                      v-model="inputNic"
                    />
                    <span class="field-error">{{ errors.inputNic }}</span>
                  </b-col>
                  <b-col sm="6" v-if="sirenConnu === true">
                    <b-form-group
                      label-for="nic"
                      :horizontal="true">
                      <!-- <b-form-radio-group id="nic" name="nic"> -->
                        <b-form-radio v-model="selected" value="nicConnu" @change="onChange()">
                          <label>Sélection d'un NIC connu: </label>
                          <b-form-select v-model="selectedNic" :options="etablissementsOptions" :disabled="selected == 'newNic'" :class="{hasError: errors.selectedNic !== ''}">
                            <template v-slot:first>
                              <b-form-select-option :value="null" disabled>-- Sélectionner --</b-form-select-option>
                            </template>
                          </b-form-select>
                          <span class="field-error">{{ errors.selectedNic }}</span>
                        </b-form-radio>
                        <b-form-radio v-model="selected" value="newNic" @change="onChange()">
                          <label>Saisie d'un nouveau NIC : </label>
                          <b-form-input
                            id="nic"
                            type="text"
                            :class="{hasError: errors.nic !== ''}"
                            v-model="nic"
                            :disabled="selected == 'nicConnu'"
                          />
                          <span class="field-error">{{ errors.nic }}</span>
                        </b-form-radio>
                      <!-- </b-form-radio-group> -->
                    </b-form-group>
                  </b-col>
                </b-row>
                <div class="mt-4" slot="footer">
                  <b-button type="submit" size="md" class="pull-right" variant="primary">
                    <i class="fa fa-arrow-right"/> Etape suivante
                  </b-button>
                  <b-button type="button" @click.prevent="cancel" size="md" class="pull-right mr-3" variant="secondary">
                    <i class="fa fa-close"/> Annuler
                  </b-button>
                </div>
              </b-form>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from '../../utils/auth';
  import { espaceEmployeurRules as rules, hasRule } from "@/utils/rulesHelper";
  import { isEmpty } from "@/utils/fileHelper";

  export default {
  data() {
      return {
      siren: '',
      sirenEtape1: '',
      etape2: false,
      sirenConnu: false,
      selectedNic: null,
      inputNic: '',
      etablissementsOptions: [],
      nic: '',
      raisonSociale: '',
      isEmpty,
      selected: 'nicConnu',
      errors: {
        siren: '',
        nic: '',
        selectedNic: '',
        inputNic: '',
      }
    }
  },
  mounted() {

  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    onChange() {
      if (this.selected === 'nicConnu') {
        this.nic = ''
        this.errors.nic = ''
      } else if (this.selected === 'newNic') {
        this.selectedNic = null
        this.errors.selectedNic = ''
      }
    },
    searchStructure() {
      if (this.validateSiren()) {
        this.$store.commit('IS_LOADING', true)
        let self = this
        this.$axios
          .get("/espaceEmployeur/inscription-cev/search/structure/" + this.siren)
          .then(response => {
            this.$store.commit("IS_LOADING", false)
            let etablissements = ''
            if (!isEmpty(response.data.etablissements)) {
              etablissements = Object.entries(response.data.etablissements)
              this.sirenConnu = true
              for (let [nic,etablissement] of etablissements) {
                this.etablissementsOptions.push({value: nic, text: etablissement})
              }
              this.etape2 = true
            } else {
              if (response.data.sirenValid === false) {
                this.errors.siren = "Le SIREN est invalide"
                this.etape2 = false
              } else {
                this.etape2 = true
              }
              this.sirenConnu = false
            }
          })
          .catch(function (error) {
            this.etape2 = false
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    searchFromBre() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true)
        let self = this
        let nic = this.selectedNic ? this.selectedNic : this.nic ? this.nic : this.inputNic
        let siret = this.siren + nic
        this.$axios
          .get("/espaceEmployeur/inscription-cev/search/structure/from-bre/" + siret)
          .then(response => {
            this.$store.commit("IS_LOADING", false)
            // this.getStructure()
            if (!isEmpty(response.data.etablissement)) {
              this.$router.push({
                path: '/espace-employeur/inscription-cev/saisie-siret',
                query: {
                  etablissement: response.data.etablissement,
                  entreprise: response.data.entreprise
                }
              });
            } else {
              if (response.data.siretValid === false) {
                this.errors.inputNic = "Le NIC n'est pas valide"
                this.errors.nic = "Le NIC n'est pas valide"
              } else {
                this.$router.push({
                  path: '/espace-employeur/inscription-cev/saisie-siret',
                  query: {
                    siren: this.siren,
                    nic: nic,
                    entreprise: response.data.entreprise
                  }
                });
              }
            }
          })
          .catch(function (error) {
            // this.etape2 = false
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    validateSiren() {
      this.clearErrors()
      let valid = true
      if (this.siren !== "") {
        this.siren = this.siren.replaceAll(' ', '')
        if (this.siren.length < 9 || this.siren.length > 9) {
          this.errors.siren = "Le SIREN doit contenir 9 caractères";
          valid = false;
        }
        if (/^\d+$/.test(this.siren) === false) {
          this.errors.siren = 'Le SIREN ne doit contenir que des chiffres'
          valid = false
        }
      } else {
        this.errors.siren = "Le SIREN est obligatoire"
        valid = false
      }
      return valid;
    },
    validateData() {
      this.clearErrors()
      let valid = true
      if (this.sirenConnu) {
        if (this.selected === 'newNic') {
          if (this.nic === "") {
            this.errors.nic = "Le NIC est obligatoire"
            valid = false
          }
        }
        if (this.selected === 'nicConnu') {
          if (this.selectedNic === null) {
            this.errors.selectedNic = "Veuillez sélectionner un établissement"
            valid = false
          }
        }
      } else {
        if (this.inputNic === "") {
          this.errors.inputNic = "Le NIC est obligatoire"
          valid = false
        }
      }
      return valid
    },
    clearErrors() {
      this.errors.siren = ""
      this.errors.nic = ""
      this.errors.inputNic = ""
      this.errors.selectedNic = ""
    },
    cancel() {
      this.etape2 = false
      this.siren = ''
    },
    getStructure() {
      this.$store.commit('IS_LOADING', true)
      let self = this
      this.$axios
        .get("/espaceEmployeur/inscription-cev/search/entreprise/" + this.siren)
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.entreprise = response.data.entreprise
        })
        .catch(function (error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    // searchAdmin() {
    //   this.$router.push({path: '/espace-employeur/inscription-cev/edit/admin'})
    // },
    // searchSiret() {
    //   this.$router.push({path: '/espace-employeur/inscription-cev/edit/siret'});
    // }
  }
}
</script>

<style scoped>
  .bleu_clair {
    cursor: pointer;
    color: #1e8eb5 !important;
  }
</style>
